<template>
  <div
    style="display:flex; align-items: center; justify-content: center; position: absolute; width: 100%; height: 100vh; left: 0; top: 0;">
    <vue-particles class="login" color="#DEDEDE" :particleOpacity="1" :particlesNumber="150" shapeType="circle"
      :particleSize="4" linesColor="#DEDEDE" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150"
      :moveSpeed="3" :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
    </vue-particles>
    <div class="login_container">
      <div class="logo">
        <img src="../../assets/imgs/logo.jpg" alt="">
      </div>
      <div class="os_name">
        <span>CRM - Powered By Alchemist</span>
      </div>
      <div class="login_form_container">
        <el-form ref="form" :model="form" label-width="80px" class="login_form">
          <el-form-item>
            <template slot="label">
              <div class="label">Account</div>
            </template>
            <el-input v-model="form.account" placeholder="请输入账号或手机号码"></el-input>
          </el-form-item>
          <el-form-item>
            <template slot="label" class="label">
              <div class="label">Password</div>
            </template>
            <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <template slot="label" class="label">
              <div class="label">Remember</div>
            </template>
            <el-switch v-model="form.autologin"></el-switch>
          </el-form-item>
          <el-form-item>
            <template slot="label" class="label">
              <div class="label">Forced</div>
            </template>
            <el-switch v-model="form.force"></el-switch>
            <i class="el-icon-warning-outline" style="margin-left: 10px;" v-if="form.force">
              Login from elsewhere will be forced offline</i>
          </el-form-item>
          <el-form-item style="float: right;">
            <el-button type="primary" @click="submit" :loading="login_btn_loading" :disabled="login_btn_disabled">{{
              login_btn_text }}</el-button>
            <el-button>Cancel</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      login_btn_text: 'Login',
      login_btn_loading: false,
      login_btn_disabled: false,
      form: {
        account: '',
        password: '',
        autologin: false,
        force: false
      }
    }
  },
  mounted() {
    // window.location.reload();
  },
  methods: {
    submit: function () {
      this.login_btn_text = "Logging in...";
      this.login_btn_loading = true;
      this.login_btn_disabled = true;

      this.$axios.post('/users/login',
        this.form
      ).then((response) => {
        let menu = [];
        if (response) {
          let res = response.data.data;
          localStorage.setItem('userinfo', JSON.stringify(res));
          sessionStorage.setItem('userinfo', JSON.stringify(res));
          this.$userinfo = res;
          this.$axios.defaults.headers.common['x-authorization-token'] = res.api_token;
          this.$router.push('/dashboard');
          if (res.user_type === 1 || res.user_type === 9 || res.account === 'alison') {
            menu = [
              { title: '统计报表', path: 'dashboard', icon: 'el-icon-data-analysis' },
              { title: '客户管理', path: 'customers', icon: 'el-icon-s-custom' },
              { title: '邮件中心', path: 'alc_mailer', icon: 'el-icon-message' },
              { title: '邮件群发', path: 'emails', icon: 'el-icon-position' },
              { title: '邮箱挖掘', path: 'deep_emails', icon: 'el-icon-view' },
              { title: '邮件分发', path: 'distribute', icon: 'el-icon-guide' },
              { title: '产品资料', path: 'products', icon: 'el-icon-s-goods' },
              { title: '待办事项', path: 'schedule', icon: 'el-icon-document' },
              // { title: '用户管理', path: 'users', icon: 'el-icon-s-help' },
              { title: '通用工具', path: 'tools', icon: 'el-icon-setting' },
              { title: '共享文件', path: 'shared_files', icon: 'el-icon-files' },
              { title: '自助建站', path: 'websites', icon: 'el-icon-office-building' }
            ];
          } else if (res.user_type === 2 && res.account !== 'alison') {
            menu = [
              { title: '统计报表', path: 'dashboard', icon: 'el-icon-data-analysis' },
              { title: '客户管理', path: 'customers', icon: 'el-icon-s-custom' },
              { title: '邮件中心', path: 'alc_mailer', icon: 'el-icon-message' },
              { title: '邮件群发', path: 'emails', icon: 'el-icon-position' },
              { title: '邮箱挖掘', path: 'deep_emails', icon: 'el-icon-view' },
              { title: '产品资料', path: 'products', icon: 'el-icon-s-goods' },
              { title: '待办事项', path: 'schedule', icon: 'el-icon-document' },
              { title: '通用工具', path: 'tools', icon: 'el-icon-setting' },
              { title: '共享文件', path: 'shared_files', icon: 'el-icon-files' },
              { title: '自助建站', path: 'websites', icon: 'el-icon-office-building' }
            ];
          } else if (res.user_type === 3) {
            menu = [
              { title: '统计报表', path: 'dashboard', icon: 'el-icon-data-analysis' },
              { title: '客户管理', path: 'customers', icon: 'el-icon-s-custom' },
              { title: '邮件中心', path: 'alc_mailer', icon: 'el-icon-message' },
              { title: '邮件群发', path: 'emails', icon: 'el-icon-position' },
              { title: '邮箱挖掘', path: 'deep_emails', icon: 'el-icon-view' },
              { title: '产品资料', path: 'products', icon: 'el-icon-s-goods' },
              { title: '待办事项', path: 'schedule', icon: 'el-icon-document' },
              { title: '通用工具', path: 'tools', icon: 'el-icon-setting' },
              { title: '共享文件', path: 'shared_files', icon: 'el-icon-files' },
              { title: '自助建站', path: 'websites', icon: 'el-icon-office-building' }
            ];
          } else if (res.user_type === 4) {
            menu = [
              { title: '统计报表', path: 'dashboard', icon: 'el-icon-data-analysis' },
              { title: '邮件群发', path: 'emails', icon: 'el-icon-position' },
              { title: '邮箱挖掘', path: 'deep_emails', icon: 'el-icon-view' },
              { title: '通用工具', path: 'tools', icon: 'el-icon-setting' },
              { title: '自助建站', path: 'websites', icon: 'el-icon-office-building' }
            ];
          } else {
          }
          localStorage.setItem('menu', JSON.stringify(menu));
          setTimeout(() => {
            window.location.reload();
          })
        } else {
          this.login_btn_text = "Log In";
          this.login_btn_loading = false;
          this.login_btn_disabled = false;
        }
      })

      this.login_btn_loading = false;
      this.login_btn_disabled = false;
    }
  }
}
</script>

<style scoped>
.login {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: url(../../assets/imgs/3c43f29fbc51f56e4ca5b624d8b37c44.jpg) no-repeat;
  background-size: 100% 100%;
  z-index: 1;
  overflow: hidden;
}

.login_container {
  width: 700px;
  height: 500px;
  position: absolute;
  top: 120px;
  z-index: 2;
}

.logo {
  width: 100%;
  text-align: center;
}

.logo img {
  width: 100px;
}

.os_name {
  color: #FFF;
  font-size: 33px;
  width: 100%;
  height: 66px;
  line-height: 66px;
  text-align: center;
  letter-spacing: 1px;
}

.login_form_container {
  width: 400px;
  padding: 50px 0 0 120px;
  color: #FFF;
}

.label {
  color: #FFF;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue